import shouldForwardProp from "@styled-system/should-forward-prop";
import { themeGet } from "../../";
import { styled, EmotionComponent } from "../../styled";
import {
  compose,
  color,
  space,
  typography,
  layout,
  position,
  textDecorationProp,
  textTransformProp,
  ColorProps,
  SpaceProps,
  LayoutProps,
  PositionProps,
  TypographyProps,
  hoverColorProp,
  HoverColorProp,
  TextTransformProp,
  OverrideNativeElementProps,
  TextDecorationProp,
  HoverTextDecorationProp,
  hoverTextDecorationProp,
} from "../../utils/styleFn";

const styleProps = compose(
  color,
  space,
  typography,
  layout,
  position,
  textTransformProp,
  textDecorationProp
);

export type LinkProps = OverrideNativeElementProps<
  HoverColorProp &
    HoverTextDecorationProp &
    ColorProps &
    SpaceProps &
    LayoutProps &
    PositionProps &
    TypographyProps &
    TextTransformProp &
    TextDecorationProp,
  "a"
>;

export const Link: EmotionComponent<LinkProps> = styled("a", {
  shouldForwardProp,
})`
  color: ${themeGet("colors.typography.link")};
  text-decoration: none;
  cursor: pointer;

  &:hover,
  &:focus {
    ${hoverColorProp}
    > span, p, svg {
      ${hoverColorProp}
    }
    ${hoverTextDecorationProp}
  }

  &:focus-visible {
    outline: 1px solid ${themeGet("colors.secondaryDark")};
    outline-offset: 2px;
  }

  &:focus[data-focus-visible-added] {
    outline: 1px solid ${themeGet("colors.secondaryDark")};
    outline-offset: 2px;
  }

  ${styleProps}
`;

Link.displayName = "Link";

Link.defaultProps = {
  hoverColor: "typography.linkHover",
  hoverTextDecoration: "underline",
};

export default Link;
